import { placeholderImage } from "../../car-reviews-v2";
export var removeDuplicatesKeepPlaceholders = function(images) {
    var seenIds = new Set();
    return images.reduce(function(uniqueImages, image) {
        var isPlaceholder = image.filename === placeholderImage.filename;
        if (isPlaceholder || !image.id || !seenIds.has(image.id)) {
            if (image.id) seenIds.add(image.id);
            uniqueImages.push(image);
        }
        return uniqueImages;
    }, []);
};
